<!-- eslint-disable vue/no-v-text-v-html-on-component -->
<template>
  <div v-click-outside="hideSearch" :class="{ 'overall-search': true, 'overall-search-should-closed': shouldHideOnSmallScreens }">
    <v-text-field
      v-model.trim="searchValue"
      variant="outlined"
      density="compact"
      clearable
      clear-icon="mdi-close"
      hide-details
      :placeholder="$lang.header.recentlyAccessed"
      prepend-inner-icon="mdi-history"
      :append-inner-icon="searchBoxClosed ? '' : 'mdi-chevron-down'"
      class="expanding-search"
      data-cy="recently-accessed-input"
      :loading="loading"
      :class="{ closed: searchBoxClosed && !searchValue }"
      @focus="searchBoxClosed = false; show = !!searchItems.length"
      @blur="searchBoxClosed = true"
      @click:clear="show = false"
    />
    <v-expand-transition v-if="show">
      <v-list class="search-result">
        <v-list-item
          v-for="(item, i) in searchItems"
          :key="i"
          class="saved-locations-result-item"
          :to="item.fullPath"
          link
          @click="show = false"
        >
          <v-list-item-title class="d-flex align-center">
            <v-icon size="small">
              {{ item.icon }}
            </v-icon>
            <div class="ms-1">
              {{ item.name }}
            </div>
          </v-list-item-title>
          <v-list-item-subtitle v-text="item.comment" />
        </v-list-item>
        <v-list-item v-if="searchValue && searchValue.length >= 3 && !searchItems.length">
          <div class="no-search-result">
            No search result
          </div>
        </v-list-item>
      </v-list>
    </v-expand-transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    shouldHideOnSmallScreens: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      show: false,
      searchValue: '',
      searchItems: [],
      searchBoxClosed: true,
      loading: false
    }
  },
  computed: {
    ...mapGetters('app', {
      savedLocations: 'savedLocations'
    })
  },
  watch: {
    searchValue: {
      handler() {
        if (!this.searchValue) {
          this.show = false
          this.searchItems = this.savedLocations
        } else {
          this.searchItems = this.savedLocations.filter(
            (item) => item.name
              .toLowerCase()
              .includes(this.searchValue.toLowerCase())
          )
        }
      }
    }
  },
  mounted() {
    this.searchItems = [...this.savedLocations]
  },
  methods: {
    hideSearch() {
      this.show = false
      this.searchBoxClosed = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .overall-search {
    display: flex;
    width: 100%;

    .result-item {
      cursor: pointer;
    }

    .search-result {
      max-height: 350px;
      position: absolute;
      overflow-x: hidden;
      overflow-y: auto;
      border: 2px solid rgb(var(--v-theme-primary));
      border-radius: 5px;
      z-index: 1;
      right: 120px;
      top: 50px;
    }

    .no-search-result {
      display: flex;
      justify-content: center;
    }

    .expanding-search {
      transition: max-width 0.5s;
      margin-left: auto;
      margin-right: 0 !important;
      width: 250px;
      max-width: 250px;

      &.closed {
        max-width: 48px;
      }

      ::v-deep(.v-field--active .v-icon) {
        color: rgb(var(--v-theme-primary)) !important;
        caret-color: rgb(var(--v-theme-primary)) !important;
      }
    }
  }

  @media screen and (max-width: 890px) {
    .overall-search-should-closed {
      display: none !important;
    }
  }
</style>
